import { lazy, Suspense } from "react";

const Real = lazy(() => import("./PhoneInput"));

function Plain({ value, onChange, className = "pp-in", testid = "phone-input", placeholder = "+39 333 1234567" }) {
  return <input type="tel" inputMode="tel" autoComplete="tel" className={className} value={value || ""} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} data-testid={testid} />;
}

export default function PhoneInputLazy(props) {
  return <Suspense fallback={<Plain {...props} />}><Real {...props} /></Suspense>;
}
